// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2aVyF","title":"AfterImages90_title__35qxy","images":"AfterImages90_images__zGYrG"};